import renderElement from './element';

export default renderElement.bind(null, 'strong');




// WEBPACK FOOTER //
// ../~/idom-util/src/strong.js